import BaseViewController from '../../common/services/base-view-controller';
import NotificationController from '../../common/notification-modal.controller';
import template from '../../common/notification-modal.html';
import saveUserTemplate from './save-user-info-modal.html';
import SendSaveUserInfoController from "./save-user-info-modal.controller";

class HomeController extends BaseViewController {

    constructor($scope, $state, LoadedModel, $uibModal, $cookies) {
        super($scope, $state, LoadedModel);
        this._$uibModal = $uibModal;
        this.viewKey = this.meshViewKey;

        const defaultUploadText = "Please upload 3D model (*.igs or *.stl only) via selection or drag and drop";
        this.meshError = defaultUploadText;
        const userInfo  = this.model.restoreUserDetails();
        if (!userInfo) {
            this.openModal();
        }
        if(this.getCurrentView()) {
            this.loadCurrentView();
        } else if(this.model.mesh) {
            this.loadViewByData({
                fileName: this.model.fileName,
                mesh: this.model.mesh,
                maxDimensions:  this.model.maxDimensions,
                offset: this.model.offset,

            }, 'mesh');
            const self  = this;
            setTimeout(()=> {
                self._$scope.$broadcast('solverFinished', {
                    step: 'part',
                });
            });
        }

        $scope.$on('meshedFileSurface', (event, data) => {
          this.showSurfaceMessage(data);
        });

        $scope.$on('partStepChanged', () => {
            this.model.invalidateStep('part');
        });

        $scope.$on('fileMeshed', (event, data) => {
            this.setMesh(data);
            this._$scope.$apply();
        });
    }

    checkThickness() {
      return !this.model.isThicknessValid()
    }

    showSurfaceMessage() {
        const message = `A solid is imported and the ${this.model.offset.name} has been selected.`;
        this._$uibModal.open({
            animation: false,
            template: template,
            controllerAs: '$ctrl',
            size: 'sm',
            resolve: {
              message: function () {
                return message;
              }
            },
            controller: NotificationController,
        });
    }

    setMesh(data) {
        this.model.fileName = data.fileName;
        this.model.mesh = data.mesh;
        if (data.lockOffset) {
          this.model._offset = data.offset;
          this.model._thickness = data.thickness;
          this.model.lockOffset = data.lockOffset;
        }
    }

    openModal() {
        this._$uibModal.open({
            size: 'sm',
            animation: false,
            template: saveUserTemplate,
            controllerAs: '$ctrl',
            backdrop:'static',
            keyboard :false,
            controller: SendSaveUserInfoController,
        });
    }
}

HomeController.$inject = ['$scope', '$state', 'LoadedModel', '$uibModal', '$cookies'];

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js